<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 class="mb-5">Gauti NTR el. paslaugų duomenys</h3>

    <zurnalas-ntr-gaunami-search :loading="loading" @search="searchGaunami" />

    <v-data-table
      class="mb-4"
      :loading="loading"
      :headers="headers"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.pra_busena_pavadinimas`]="{ item }">
        <el-prasymas-busena :busena="item.pra_busena_pavadinimas" />
      </template>
      <template #[`item.salys`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12" v-for="salis in item.salys" :key="salis">
            {{ salis }}
          </v-col>
          <v-col cols="12" md="12" v-if="item.salysCut">
            ...
          </v-col>
        </v-row>
      </template>
      <template #[`item.turtai`]="{ item }">
        <v-row dense no-gutters>
          <v-col
            v-for="turtas in item.turtai"
            :key="turtas"
            class="mb-2"
            cols="12"
            md="12"
          >
            <div class="nowrap">{{ turtas }}</div>
          </v-col>
          <v-col cols="12" md="12" v-if="item.turtaiCut">
            ...
          </v-col>
        </v-row>
      </template>
      <template #[`item.pra_perdavimo_data`]="{ item }">
        <div class="nowrap">{{ item.pra_perdavimo_diena }}</div>
        <div class="nowrap">{{ item.pra_perdavimo_laikas }}</div>
      </template>
      <template #[`item.pra_busenos_data`]="{ item }">
        <div class="nowrap">{{ item.pra_busenos_diena }}</div>
        <div class="nowrap">{{ item.pra_busenos_laikas }}</div>
      </template>
      <template #[`item.pra_sutvarkyti_iki`]="{ item }">
        <div class="nowrap">{{ item.pra_sutvarkyti_iki_diena }}</div>
        <div class="nowrap">{{ item.pra_sutvarkyti_iki_laikas }}</div>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @viewItem="editItem(item)"
            @viewArchyvasItem="archyvasItem(item)"
            @deleteItem="deleteItem(item)"
            @restoreItem="restoreItem(item)"
          />
        </div>
        <v-tooltip top v-if="item.pra_tikrina">
          <template v-slot:activator="{ on, attrs }">
            <v-chip small outlined class="mt-1 mb-1" v-bind="attrs" v-on="on">
              <div class="tikrina-chip text-truncate">
                Tikrina {{ item.pra_tikrina }}
              </div>
            </v-chip>
          </template>
          <div class="tooltip-text">
            Tikrina<br />
            {{ item.pra_tikrina }}
          </div>
        </v-tooltip>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template slot="loading">
        kraunasi
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="
          printData(
            'ntrpaslaugos/prasymai/print',
            'Gauti NTR el. paslaugų duomenys'
          )
        "
        :disabled="canPrint"
        :loading="loading"
        >Spausdinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ZurnalasNtrGaunamiSearch from './ZurnalasNtrGaunamiSearch'
import print from '@/mixins/print'
import userRole from '@/mixins/userRole'

export default {
  name: 'ZurnalasNtrGaunami',
  components: {
    ZurnalasNtrGaunamiSearch,
  },
  mixins: [userRole, print],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      zurnalas_gaunami: [],
      searchData: {},
      headers: [
        {
          text: 'Registracijos numeris',
          align: 'start',
          value: 'pra_numeris',
        },
        {
          text: 'Prašymo numeris',
          align: 'start',
          value: 'pra_dokumento_numeris',
        },
        {
          text: 'Gavimo data ir laikas',
          align: 'start',
          value: 'pra_perdavimo_data',
        },
        {
          text: 'Prašymo rūšis',
          align: 'start',
          value: 'pra_tipas_pavadinimas',
        },
        {
          text: 'Šalys',
          align: 'start',
          sortable: false,
          value: 'salys',
        },
        {
          text: 'Unikalus numeris',
          align: 'start',
          sortable: false,
          value: 'turtai',
        },
        {
          text: 'Duomenų teikėjas',
          align: 'start',
          sortable: false,
          value: 'teikejas',
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'pra_busena_pavadinimas',
        },
        {
          text: 'Būsenos data ir laikas',
          align: 'start',
          value: 'pra_busenos_data',
        },
        {
          text: 'Sutvarkyti iki',
          align: 'start',
          value: 'pra_sutvarkyti_iki',
        },
        {
          text: 'Vykdytojas',
          align: 'start',
          sortable: false,
          value: 'pra_vykdo',
        },
        {
          text: 'Paskutinis veiksmus atlikęs asmuo',
          align: 'start',
          sortable: false,
          value: 'pra_atnaujino',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      lockInterval: null,
      lockTimeout: 10000,

      archyvasTitle: null,
      archyvasText: null,
      archyvasBylos: [],
      showArchyvasBylos: false,
    }
  },
  computed: {
    ...mapGetters(['getLockObjId', 'listInfo']),

    filterItemList() {
      return this.zurnalas_gaunami.map(item => {
        const maxSalis = 3
        item.salysCut = false
        if (item.salys.length > maxSalis) {
          item.salys = item.salys.slice(0, maxSalis)
          item.salysCut = true
        }

        const maxTurtai = 3
        item.turtaiCut = false
        if (item.turtai.length > maxTurtai) {
          item.turtai = item.turtai.slice(0, maxTurtai)
          item.turtaiCut = true
        }

        if (item.pra_uzrakinta) {
          item.canLock = true
          item.lockMsg = item.pra_uzrakines_asmuo
        } else {
          item.canEdit =
            (item.pra_busena === 'perduotas' ||
              item.pra_busena === 'grazintas') &&
            !this.role('RG_NTR_vadovas')
          item.canView = !item.canEdit
        }
        if (item.pra_pasirasymas_vadovas) {
          if (
            this.roleRGV &&
            (item.pra_busena_tolimesne === 'atmestas' ||
              item.pra_busena_tolimesne === 'grazintas')
          ) {
            item.showSign = true
          }

          if (this.role('RG_NTR_vadovas') && !item.pra_uzrakinta) {
            item.canEdit = true
            item.canView = false
          }

          if (
            item.pra_busena === 'perduotas' &&
            !this.role('RG_NTR_vadovas') &&
            !item.pra_uzrakinta
          ) {
            item.canView = true
            item.canEdit = false
            item.canDelete = false
          }
        }
        if (item.laukia_patvirtinimo) {
          item.canEdit = false
          item.canDelete = false
          item.canView = true
          item.showConfirm = true
          item.showConfirmText = `Laukia ${item.pra_registratoriai_aktyvus} patvirtinimo`
        }
        if (!item.pra_id) {
          item.canView = false
        }

        if (this.roleSkaitytojas) {
          item.canEdit = false
          item.canView = true
          item.canDelete = false
        }

        return item
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
    isLocked() {
      return this.zurnalas_gaunami.filter(item => item.pra_uzrakinta).length > 0
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
  created() {
    //
  },
  methods: {
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`ntrpaslaugos/prasymai`, data)
        .then(res => {
          this.zurnalas_gaunami = res.data.zurnalas_gaunami
          this.pagination = { ...this.pagination, ...res.data.pagination }
          this.checkLoading()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchGaunami(searchData) {
      this.searchData = searchData
      this.loading = true

      let resetPageNr = true
      if (this.$route.params.toList) {
        this.pagination = this.listInfo.pagination
        resetPageNr = false
        this.$route.params.toList = false
      }
      this.getData(resetPageNr)
    },
    checkLoading() {
      if (this.isLocked) {
        if (!this.lockInterval) {
          this.lockInterval = setInterval(() => {
            this.getData()
          }, this.lockTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.lockInterval)
    },
    editItem(item) {
      const prasymasID = item.pra_id
      this.$store.dispatch('prasymasID', prasymasID)
      const listInfo = {
        pra_id: item.pra_id,
        routeName: 'zurnalasNtrGaunami',
        pagination: this.pagination,
        search: this.searchData,
      }
      this.$store.dispatch('listInfo', listInfo).then(
        this.$router.push({
          name: 'regPrasymasRegistravimas',
          params: {
            prasymasID: prasymasID,
          },
        })
      )
    },
    rowClass(item) {
      if (item.pra_busena === 'nepatikslintas') {
        return `zurnalas-outdate`
      }
      if (item.pra_sutvarkyti_status === 'warning') {
        return `zurnalas-warning`
      }
      if (item.pra_sutvarkyti_status === 'outdate') {
        return `zurnalas-outdate`
      }
      if (item.pra_sutvarkyti_status === 'repost') {
        return `zurnalas-repost`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
